module.exports = __webpack_public_path__ + "static/Circuit_Breaker-5b5a03473935bf4a443a7112a4ca81a8.png";